import React, { Component } from "react";
import { observer } from "mobx-react";
import { AxiosError, AxiosResponse } from "axios";
import LoginForm from "./LoginForm";
import SignupForm from "./SignupForm";
import LoginStore from "../../../../stores/LoginStore";
import { Api } from "../../../../utils/Api";

interface Props {
  loginStore: LoginStore;
  loginUser: (e: React.MouseEvent<HTMLElement>) => void;
}

interface State {
  phase: "email" | "password";
  lookingUp: boolean;
  error: string;
}

interface LookupResponse {
  exists: boolean;
}

class Forms extends Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      phase: "email",
      lookingUp: false,
      error: "",
    };
  }

  handleEmailLookup = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();

    const { loginStore } = this.props;
    const email = loginStore.email.trim();

    if (!email) {
      this.setState({ error: "Pop your email in first." });
      return;
    }

    this.setState({ lookingUp: true, error: "" });

    const token = $('meta[name="csrf-token"]').attr("content");
    const client = new Api({});

    client
      .post<LookupResponse, { session: { email: string } }>(
        "/session/email/lookup.json",
        { session: { email } },
        {
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": token,
          },
        },
      )
      .then((response: AxiosResponse<LookupResponse>) => {
        if (response.data.exists) {
          loginStore.login();
        } else {
          loginStore.signUp();
        }

        this.setState({ phase: "password", lookingUp: false });
      })
      .catch((error: AxiosError<{ errors?: string }>) => {
        this.setState({
          lookingUp: false,
          error:
            error.response?.data?.errors ||
            "Sorry, we could not check that email. Try again.",
        });
      });
  };

  handleEditEmail = () => {
    this.props.loginStore.setPassword({ target: { value: "" } });
    this.props.loginStore.setPasswordConfirmation({ target: { value: "" } });
    this.setState({ phase: "email", error: "" });
  };

  renderEmailLookup = () => {
    const { loginStore } = this.props;
    const { lookingUp } = this.state;

    return (
      <form noValidate={true} className="signin-form">
        <div className="field">
          <div className="signin-input">
            <input
              className="string email optional fluid input-fields"
              placeholder="Email"
              type="email"
              name="session[email]"
              id="session_email_lookup"
              autoComplete="email"
              value={loginStore.email}
              onChange={(e) => loginStore.setEmail(e)}
            />
          </div>
          <div className="action">
            <button
              className={`btn btn-blue signin-submit ${
                lookingUp ? "loading" : ""
              }`}
              disabled={lookingUp}
              onClick={this.handleEmailLookup}
            >
              {lookingUp ? "" : "Continue"}
            </button>
          </div>
        </div>
      </form>
    );
  };

  renderForms = () => {
    const { loginStore, loginUser } = this.props;
    const { phase } = this.state;
    const { state } = loginStore;

    if (phase === "email") {
      return this.renderEmailLookup();
    }

    switch (state.kind) {
      case "ready":
      case "saving":
      case "readyWithErrors": {
        switch (state.mode) {
          case "login":
            return (
              <LoginForm
                store={loginStore}
                loginUser={loginUser}
                onEditEmail={this.handleEditEmail}
              />
            );

          case "signUp":
            return (
              <SignupForm
                store={loginStore}
                loginUser={loginUser}
                onEditEmail={this.handleEditEmail}
              />
            );
        }
      }

      default:
        return <div />;
    }
  };

  render() {
    const { error } = this.state;
    return (
      <div className="forms">
        <div className={`login-error ${error ? "" : "forceHide"}`}>
          <i className="warning icon"></i>
          <span>{error}</span>
        </div>
        <div className="forceHide login-error" id="new-login-errors">
          <i className="warning icon"></i>
          <span></span>
        </div>
        {this.renderForms()}
      </div>
    );
  }
}

export default observer(Forms);
